export const SESSION_CLOSED_BANNERS = 'closedBanners';
export const CLOSED_LYFE_CYCLE = 24;
export const BANNER_APPLIED = 'applied';
export const BANNER_EXPIRES_SOON = 'expiresSoon';
